<template>
  <div v-if="detail" class="container">
    <h2>{{ detail.identity_name }}</h2>
    <ul>
      <li>
        <label>手机号：</label>
        <p>{{ detail.phone }}</p>
      </li>
      <li>
        <label>身份证号：</label>
        <p>{{ detail.idcard }}</p>
      </li>
      <li>
        <label>银行卡号：</label>
        <p>{{ detail.bank_card_number }}</p>
      </li>
      <li style="width:100%">
        <label>id：</label>
        <p>{{ detail.id }}</p>
      </li>
      <li>
        <label>表格日期：</label>
        <p>{{ detail.salary_date }}</p>
      </li>
      <li>
        <label>上传时间：</label>
        <p>{{ detail.create_time }}</p>
      </li>
      <li>
        <label>修改时间：</label>
        <p>{{ detail.update_time }}</p>
      </li>
      <li>
        <label>结算单号：</label>
        <p>{{ detail.batch_no }}</p>
      </li>
      <li>
        <label>订单号：</label>
        <p>{{ detail.order_id }}</p>
      </li>
      <li>
        <label>服务单价：</label>
        <p>{{ detail.service_price }}</p>
      </li>
      <li>
        <label>服务数量：</label>
        <p>{{ detail.service_num }}</p>
      </li>
      <li>
        <label>服务类型：</label>
        <p>{{ detail.service_type }}</p>
      </li>
      <li>
        <label>状态：</label>
        <p>
          {{
            detail.send_status == 1
              ? "待发"
              : detail.send_status == 2
              ? "已发"
              : "失败"
          }}
        </p>
      </li>
      <li>
        <label>结算金额：</label>
        <p>{{ detail.pre_amount }}</p>
      </li>
      <li>
        <label>实发金额：</label>
        <p>{{ detail.real_amount }}</p>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: ""
    };
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  props: {
    detailVal: {}
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 50px 2%;

  h2 {
    font-size: 20px;
    margin: 20px 0;
  }

  > ul {
    li {
      display: inline-block;
      width: 30%;
      margin-bottom: 20px;

      label,
      p {
        display: inline-block;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>
